const $$splitComponentImporter = () => import('/app/src/routes/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
type ComponentType = "drivers" | "weather" | "positions" | "racetrack";
interface ComponentConfig {
  id: string;
  type: ComponentType;
  title: string;
  defaultSize: {
    w: number;
    h: number;
  };
}